import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';

const HomePage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    if (location.pathname === '/') {
      navigate('/dashboard/inspection', { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <Outlet></Outlet>
    </>
  );
};

export default HomePage;
